// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <div>
    <div v-if="isMobile" id="list-view">
      <v-container fluid grid-list-md style="!important padding: 0px;">
        <v-row wrap>
          <template v-for="(image, i) in getImages">
            <v-col lg="4" md="6" cols="12" :key="i">
              <router-link :to="{ name: 'imageEdit', params: { id: image.id }}" >
                <v-card id="card-container" height="100%">
                  <v-container fill-height>
                    <v-layout fill-height>
                      <v-flex xs5 fill-height>
                        <img :ref="'img' + i" v-bind:src="endpoint + `images/` + image.id + `/mini`" v-on:load="rotateImage($refs['img' + i], (image.exif_data && image.exif_data.orientation ? image.exif_data.orientation.value : 1), true)">
                      </v-flex>
                    <v-flex xs7>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon>watch_later</v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>{{ image.timestamp | formatDate }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <div class="tag_container_mobile">
                        <v-chip small v-for="category in image.categories" :key="category.id" class="tag blue lighten-2">
                          <p class="tagp">
                            <a href="javascript:;"
                            @click.stop="searchCategory(category)"
                            style="color: black">
                              {{ category.name }}
                            </a>
                          </p>
                        </v-chip>
                        <v-chip small v-for="(tag, j) in image.tags" :key="(10000 + i * 10000) + j" class="tag green lighten-2">
                          <p class="tagp">
                            <a
                            href="javascript:;"
                            @click.stop="searchTag(tag)"
                            style="color: black">
                              {{ tag }}
                            </a>
                          </p>
                        </v-chip>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </router-link>
            </v-col>
          </template>
        </v-row>
      </v-container>
    </div>
    <div id="grid-view" v-else style="margin: 0px;">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-progress-linear v-if="getLoading" :indeterminate="true"></v-progress-linear>
          <v-flex flexbox v-for="(image, i) in getImages" :key="image.id">
            <v-card hover tile v-bind:height="image_card_height" :style="`background-color:${backgroundColor}`">
              <div class="check_container">
                <v-btn icon @click="clickCheck(i)"><v-icon :style="checkStyle(image.selected)">check_circle</v-icon></v-btn>
              </div>
              <v-flex class="quick_actions">
                <div v-if="image.location.coordinates[0] != 0 && image.location.coordinates[1] != 0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" @click="openMaps(image.location)"><v-icon style="color:rgb(255,255,255,0.5);">gps_fixed</v-icon></v-btn>
                    </template>
                    <span>View Maps</span>
                  </v-tooltip>
                </div>
                <div v-if="image.annotation.trim()" class="comment_container">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" @click="getSelectedComment(image.annotation)"><v-icon style="color:rgb(255,255,255,0.5);">comment</v-icon></v-btn>
                    </template>
                    <span>View Comment</span>
                  </v-tooltip>
                </div>
              </v-flex>
              <div class="tag_container" @click="clickImage(i , image.id)">
                <!-- spacer chip so none appears under the checkbox -->
                <v-chip disabled cursor="pointer" style="background-color: rgba(0, 0, 0, 0.0);">&nbsp;</v-chip>
                <v-chip
                v-for="category in image.categories"
                :key="category.id"
                :class="` tag blue ${tagTheme} `"
                :disabled="selectionMode"
                @click.stop="clickCategory(i, category)"
                small
                :title="'Search: Category = ' + category.name"
                >
                  <p class="tagp">{{ category.name }}</p>
                </v-chip>
                <v-chip
                v-for="(tag, j) in image.tags"
                :key="(10000 + i * 10000) + j"
                :title="'Search: Tag = ' + tag"
                :class="` tag green ${tagTheme} `"
                :disabled="selectionMode"
                small
                @click.stop="clickTag(i, tag)">
                 <p class="tagp">{{ tag }}</p>
                </v-chip>
              </div>
              <img
                @click="clickImage(i , image.id)"
                class="image"
                :src="endpoint + 'images/' + image.id + '/mini'"
                :height="thumbnailHeight"
                :style="checkStyleBorder(image.selected)"
                :ref="'img' + i"
                v-on:load="rotateImage($refs['img' + i], (image.exif_data && image.exif_data.orientation ? image.exif_data.orientation.value : 1), true)"
              />
              <div
                id="image_tags_box"
                class="text-xs-right nowrapping"
                @click="clickImage(i , image.id)">
                {{ image.timestamp | formatDate }}
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>


    <v-tooltip left v-if="selectionMode || isQuery">
      <template v-slot:activator="{ on }">
        <v-btn @click="startDeleteDialog()" fab dark small class="red" id="smallButtonFab" style="bottom: 145px;" v-on="on">
          <v-icon>delete</v-icon>
        </v-btn>
      </template>
      <span>Delete Images</span>
    </v-tooltip>

    <v-menu offset-x left v-if="selectionMode || isQuery">
      <template v-slot:activator="{ on: menu }">
        <v-tooltip left>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn fab small dark class="blue" id="smallButtonFab" style="bottom: 90px;" v-on="{ ...tooltip, ...menu }">
              <v-icon>get_app</v-icon>
            </v-btn>
          </template>
          <span>Export Data Menu</span>
        </v-tooltip>
      </template>
      <v-list>
      <v-list-item @click="clickDownload()" v-if="selectionMode">
        <v-list-item-title>Download Individual Images</v-list-item-title>
      </v-list-item>
      <v-list-item @click="clickDownloadZip()">
        <v-list-item-title>Download Zipped Images</v-list-item-title>
      </v-list-item>
      <v-list-item @click="clickDownloadCSV()">
        <v-list-item-title>Download CSV Data</v-list-item-title>
      </v-list-item>
    </v-list>
    </v-menu>

    <v-tooltip left v-if="selectionMode">
      <template v-slot:activator="{ on }">
        <v-btn @click="clickClear()" fab dark class="amber" id="buttonFab" v-on="on">
          <v-icon>clear</v-icon>
        </v-btn>
      </template>
      <span>Clear Selection</span>
    </v-tooltip>
    <v-tooltip left v-else>
      <template v-slot:activator="{ on }">
        <v-btn  fab dark class="green" @click.native="uploadClick" id="buttonFab" transition="scale-transition" v-on="on">
          <v-icon v-if="progress === 0">add</v-icon>
          <v-progress-circular v-else-if="progress === 100" indeterminate></v-progress-circular>
          <v-progress-circular v-else v-bind:value="progress">{{ progress }}</v-progress-circular>
        </v-btn>
      </template>
      <span>Upload Image</span>
    </v-tooltip>

    <v-dialog v-model="showDeleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <div class="headline">Confirm Delete</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete all the selected images?  <b>This action cannot be undone.</b></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDeleteDialog = false">Cancel</v-btn>
          <v-btn flat color="red" @click="deleteImagesIndividual()">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCommentDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <h4>Comment </h4>
        </v-card-title>
        <div class="h-line"></div>
        <v-card-text style="white-space:pre-wrap;">{{selectedComment}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteQueryDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <div class="headline">Confirm Delete</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete all {{ getNumImages }} images that satisfy this query?<b>
          This action cannot be undone.</b> Type <b>Delete</b> below to delete the images.
          <v-text-field
          label="Delete"
          v-model="deleteText"
          :rules="[deleteTextRule]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDeleteQueryDialog = false
          deleteText=''">Cancel</v-btn>
          <v-btn flat color="red" @click="deleteImagesQuery()" :disabled="!canDeleteQuery">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <input id="file-input" type="file" style="display: none;" @change="uploadFile" />
    <error-snackbar v-model="errorText"></error-snackbar>
    <v-dialog v-model="downloading" width="500">
      <v-card>
        <v-card-title>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <div class="headline ml-3">Zipping & Downloading...</div>
        </v-card-title>
        <v-card-text>(Click anywhere to continue)</v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import {ENDPOINT} from '@/shared/constants'
  import {ImageRotatorMixin} from '../shared/mixins'
  import ApiRequests from '@/api/ApiRequests'
  import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'

  export default {
    components: {
      ErrorSnackbar
    },

    data () {
      return {
        downloading: false,
        showCommentDialog: false,
        selectedComment: '',
        deleteText: '',
        endpoint: ENDPOINT,
        errorText: '',
        progress: 0,
        showDeleteDialog: false,
        showDeleteQueryDialog: false,
        showImageTags: true,
        showUploadFile: true,
        thumbnailHeight: '200px'
      }
    },

    mixins: [ImageRotatorMixin],

    computed: {
      ...mapGetters([
        'getCategories',
        'getImages',
        'getLoading',
        'getNumImages',
        'getQuery',
        'getQueryOutput',
        'isQuery'
      ]),

      canDeleteQuery: function () {
        return this.deleteText.toLowerCase() === 'delete'
      },

      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

      backgroundColor: function () {
        if (this.$vuetify.theme.isDark) {
          return '#363636'
        } else {
          return 'white'
        }
      },

      tagTheme: function () {
        if (this.$vuetify.theme.isDark) {
          return 'darken-2'
        } else {
          return 'lighten-2'
        }
      },

      image_card_height: function () {
        if (this.showImageTags) {
          return 'auto'
        } else {
          return this.thumbnailHeight
        }
      },

      selectedImages: function () {
        var ids = []
        for (var i = 0; i < this.getImages.length; i++) {
          if (this.getImages[i].selected) {
            ids.push(this.getImages[i])
          }
        }
        return ids
      },

      selectedImageIds: function () {
        return this.selectedImages.map(x => x.id)
      },

      selectionMode: function () {
        return this.selectedImages.length > 0
      }
    },

    created () {
      var query = {}
      Object.assign(query, this.$route.query)
      if (Object.keys(query).length > 0) {
        this.searchSetQuery(query)
      }

      this.search()
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('focus', this.handleFocus)
      window.addEventListener('resize', this.handleFocus)
    },

    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('focus', this.handleFocus)
      window.removeEventListener('resize', this.handleFocus)
    },

    watch: {
      getQueryOutput: function () {
        this.search()
      }
    },

    methods: {
      ...mapActions([
        'fetchCategories',
        'fetchImages',
        'incrementLimit'
      ]),

      ...mapMutations([
        'searchCategory',
        'searchClear',
        'searchSetQuery',
        'searchTag',
        'toggleImageSelected'
      ]),

      getSelectedComment: function (comment) {
        this.showCommentDialog = true
        this.selectedComment = comment
      },

      openMaps: function (location) {
        window.open('https://www.google.com/maps/search/?api=1&query=' + location.coordinates[1] + ',' + location.coordinates[0])
      },

      clickCheck: function (index) {
        this.toggleImageSelected(index)
      },

      clickCategory: function (index, category) {
        if (!this.selectionMode) {
          this.searchCategory(category)
        } else {
          this.toggleImageSelected(index)
        }
      },

      clickClear: function () {
        for (var i = 0; i < this.getImages.length; i++) {
          if (this.getImages[i].selected) {
            this.toggleImageSelected(i)
          }
        }
      },

      deleteImagesQuery: function () {
        ApiRequests.deleteImages(this.getQueryOutput).then(r => {
          this.searchClear()
          this.showDeleteQueryDialog = false
        }).catch(e => {
          console.log(e)
          this.errorText = 'Error deleting images'
          this.showDeleteQueryDialog = false
        })
        this.deleteText = ''
      },

      deleteImagesIndividual: function () {
        var proms = []
        for (var i = 0; i < this.selectedImages.length; i++) {
          proms.push(ApiRequests.deleteImage(this.selectedImages[i].id))
        }
        Promise.all(proms).then(() => {
          this.fetchImagesGlobal()
          this.showDeleteDialog = false
        }).catch(e => {
          console.log(e)
          this.errorText = 'Error deleting images'
          this.showDeleteDialog = false
        })
      },

      deleteTextRule: function (x) {
        if (this.canDeleteQuery) {
          return true
        }
        return 'Enter "Delete" to delete images.'
      },

      clickDownloadCSV: function () {
        var url = ''
        if (this.selectionMode) {
          url = ENDPOINT + 'images/' + this.selectedImageIds + '/csv'
        } else {
          url = ENDPOINT + 'images//csv?' + new URLSearchParams(this.getQueryOutput).toString()
        }

        var link = document.createElement('a')
        document.body.appendChild(link)
        link.setAttribute('href', url)
        link.setAttribute('download', '')
        link.click()
        link.remove()
        this.downloading = true
      },

      clickDownloadZip: function () {
        var url = ''
        if (this.selectionMode) {
          url = ENDPOINT + 'images/' + this.selectedImageIds + '/zip'
        } else {
          url = ENDPOINT + 'images//zip?' + new URLSearchParams(this.getQueryOutput).toString()
        }

        var link = document.createElement('a')
        document.body.appendChild(link)
        link.setAttribute('href', url)
        link.setAttribute('download', '')
        link.click()
        link.remove()
        this.downloading = true
      },

      clickDownload: function () {
        this.downloadNext(0)
      },

      downloadNext: function (i) {
        if (i >= this.selectedImages.length) {
          return
        }
        var link = document.createElement('a')
        document.body.appendChild(link)
        link.setAttribute('href', 'api/images/' + this.selectedImages[i].id)
        var ext = '.jpg'
        if (this.selectedImages[i].cloud_photos.length > 0) {
          if (this.selectedImages[i].cloud_photos[0].format && this.selectedImages[i].cloud_photos[0].format !== '') {
            ext = '.' + this.selectedImages[i].cloud_photos[0].format
          }
        }
        link.setAttribute('download', this.selectedImages[i].id + ext)
        link.click()
        link.parentNode.removeChild(link)
        link.remove()
        // timeout required for firefox and ie
        setTimeout(() => {
          this.downloadNext(i + 1)
        }, 100)
      },

      clickImage: function (index, id) {
        if (this.showCommentDialog) {
          console.log('Click Image')
        } else if (!this.selectionMode) {
          this.$router.push({'name': 'imageEdit', 'params': { 'id': id }})
        } else {
          this.clickCheck(index)
        }
      },

      clickTag: function (index, tag) {
        if (!this.selectionMode) {
          this.searchTag(tag)
        } else {
          this.toggleImageSelected(index)
        }
      },

      checkStyle: function (selected) {
        if (selected) {
          return 'color: rgb(25, 118, 210);'
        } else {
          return 'color: rgba(255, 255, 255, 0.5);'
        }
      },

      checkStyleBorder: function (selected) {
        if (selected) {
          return 'outline: 8px solid rgb(204, 230, 255); outline-offset: -8px;'
        } else {
          return ''
        }
      },

      handleScroll: function () {
        if ((window.scrollY + window.innerHeight) >= (document.body.scrollHeight - 400)) {
          this.incrementLimit()
        }
      },

      handleFocus: function () {
        this.downloading = false
      },

      fetchImagesGlobal: function () {
        this.fetchImages()
        if ((window.scrollY + window.innerHeight) === document.body.scrollHeight) {
          this.incrementLimit()
        }
      },

      search: function (query) {
        this.$router.push({name: 'images', query: this.getQueryOutput})
        this.fetchImagesGlobal()
      },

      startDeleteDialog: function () {
        if (this.selectionMode) {
          this.showDeleteDialog = true
        } else if (this.isQuery) {
          this.showDeleteQueryDialog = true
        }
      },

      uploadFile: function (event) {
        var config = {
          onUploadProgress: (progressEvent) => {
            this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          }
        }

        var files = event.target.files
        for (var i = 0; i < files.length; i++) {
          ApiRequests.createImage(files[i], config).then(response => {
            if ((response.data.location.coordinates[0] === 0) && ('geolocation' in navigator)) {
              navigator.geolocation.getCurrentPosition((x) => {
                var coords = [x.coords.longitude, x.coords.latitude]
                var data = response.data
                data.location = {coordinates: coords}
                ApiRequests.putImageProperties(response.data.id, data).then(response => {
                  this.$router.push({name: 'imageEdit', params: {id: response.data.id}, query: {fromUpload: true}})
                })
                .catch(e => {
                  console.log(e)
                  this.$router.push({name: 'imageEdit', params: {id: response.data.id}, query: {fromUpload: true}})
                })
              }, (e) => {
                console.log(e)
                this.$router.push({name: 'imageEdit', params: {id: response.data.id}, query: {fromUpload: true}})
              })
            } else {
              this.$router.push({name: 'imageEdit', params: {id: response.data.id}, query: {fromUpload: true}})
            }
          })
          .catch(e => {
            this.progress = 0
            this.errorText = 'Error uploading file'
            console.log(e)
          })
        }
      },

      uploadClick: function () {
        document.getElementById('file-input').click()
      }
    }
  }
</script>

<style scoped>
  .container {
    padding: 8px !important;
  }

  a {
    text-decoration: none;
    color: black;
  }

  #grid-view {
    color: #fff;
    text-align: right;
    margin: 8px;
  }

  #grid-view .flex {
    flex-grow: 0;
  }

  #grid-view .card {
    display: inline-block;
  }

  #list-view .card {
    min-width: 150px;
    min-height: 200px;
  }

  #list-view img {
    max-height: 100%;
    max-width: 100%;
    display: block;
    position: relative;
  }

  #card-container .container {
    padding: 6px;
  }

  #card-container .layout {
    margin: 0px;
  }

  #card-container .flex{
    padding: 0px;
  }

  #image_tags_box {
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 4px;
  }

  #smallButtonFab {
    position: relative;
    overflow: hidden;
    position: fixed;
    right: 28px;
    z-index: 4;
  }

  #buttonFab {
    position: relative;
    overflow: hidden;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 4;
  }

  .check_container {
    position:absolute;
    z-index:2;
  }

  .quick_actions {
    position:absolute;
    z-index:2;
    bottom:30px;
    left:0px;
  }

  .h-line {
    background-color:rgb(141, 141, 141);
    margin-left:auto;
    margin-right:auto;
    margin-bottom:7px;
    width:90%;
    height:1px;
  }


  .tag {
    max-width: calc(100% - 8px);
    margin:1px;
  }

  >>>.v-chip__content {
    max-width: calc(100%);
  }

  .tagp {
    margin: 0px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .tag_container {
    position:absolute;
    right:0px;
    bottom:30px;
    overflow-y: hidden;
    overflow-x: hidden;
    height: 200px;
    width: 100%;
    z-index:1;
  }

  .tag_container_mobile {
    margin: 4px;
  }

  .chip {
    margin: 0px 3px 6px 3px !important;
    font-size: 12px !important;
    height: 21px !important;
    opacity: .7;
  }

  .nowrapping {
    white-space: nowrap;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// ImageList.vue?519005d6